document.addEventListener("DOMContentLoaded", function () {
  var collapsibleItems = document.querySelectorAll(".collapsible-grid__item");
  collapsibleItems.forEach(function (item) {
    if (item.innerHTML.trim() === "") {
      var myNon = document.getElementById("my-non");
      if (myNon) {
        myNon.style.display = "none";
      }
    }
  });
});
